import type { CategoryBanner } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import Link from 'next/link'
import { type FC } from 'react'
import type { Settings } from 'react-slick'
import Slider from 'react-slick'
import CarrouselArrowIconMiddle from '../Icon/CarrouselArrowIconMiddle'
import ImageOptimize from '../ImageOptimize'

interface Props {
  data: CategoryBanner[]
}
export const BannerProductListing: FC<Props> = ({ data }: Props) => {
  const settings: Settings = {
    slidesToScroll: 1,
    arrows: true,
    infinite: true,
    speed: 800,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    variableWidth: false,
    nextArrow: <CarrouselArrowIconMiddle type='next' />,
    prevArrow: <CarrouselArrowIconMiddle type='prev' />,
  }
  const settingsNonSlider: Settings = {
    swipe: false,
    slidesToShow: 1,
    infinite: false,
    variableWidth: false,
    draggable: false,
  }
  const sliderCategoryData = data
    .filter(e => e.type === 'slider')
    ?.sort((a, b) => a.order - b.order)
  const bannerCategoryData = data
    .filter(e => e.type === 'fixed')
    ?.sort((a, b) => a.order - b.order)
  return (
    <>
      {data.length > 0 && (
        <section className='categoryBanner mb-[32px] flex flex-wrap gap-[20px]'>
          {data && sliderCategoryData && sliderCategoryData.length > 0 ? (
            <div className='sliderCate w-full'>
              {sliderCategoryData.length > 0 ? (
                <Slider {...settings} className=''>
                  {sliderCategoryData.map((e, i) => (
                    <Link
                      className='block w-full overflow-hidden rounded-lg'
                      href={e.path || ''}
                      key={i}
                    >
                      <ImageOptimize
                        src={e.image || ''}
                        width={1312}
                        height={387}
                        alt={getTranslate(e.name)}
                        priority
                        className='h-auto w-full'
                      />
                    </Link>
                  ))}
                </Slider>
              ) : (
                <Slider
                  {...settingsNonSlider}
                  className='non-slick ml-0 mr-auto flex w-full'
                >
                  {sliderCategoryData.map((e, i) => (
                    <Link
                      className='block w-full overflow-hidden rounded-lg'
                      href={e.path || ''}
                      key={i}
                    >
                      <ImageOptimize
                        src={e.image || ''}
                        width={1312}
                        height={387}
                        alt={getTranslate(e.name)}
                        className='h-auto w-full'
                        priority
                      />
                    </Link>
                  ))}
                </Slider>
              )}
            </div>
          ) : (
            ''
          )}
          {data && bannerCategoryData && bannerCategoryData.length > 0 ? (
            <div className='fixBanner grid grid-cols-3 gap-5'>
              {bannerCategoryData.slice(0, 3).map((e, i) => {
                return (
                  <Link className='block w-full' href={e.path || ''} key={i}>
                    <ImageOptimize
                      src={e.image || ''}
                      width={415}
                      height={151}
                      alt={''}
                      priority
                      className='h-auto w-full overflow-hidden rounded-lg'
                    />
                  </Link>
                )
              })}
            </div>
          ) : (
            ''
          )}
        </section>
      )}
    </>
  )
}
